import script from "./AbilityItem.vue?vue&type=script&setup=true&lang=js"
export * from "./AbilityItem.vue?vue&type=script&setup=true&lang=js"

import "./AbilityItem.vue?vue&type=style&index=0&id=33116eb2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33116eb2"]])

export default __exports__